import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";
import { cn } from "@/lib/utils";

/** Renders AI-generated markdown (bullets, bold, tables, headings) plus LaTeX math
 * ($...$ inline, $$...$$ block) as real formatted output instead of raw text. Use
 * anywhere a model response is shown — chatbot replies, check reasoning, reports. */
export function Markdown({ content, className }: { content: string; className?: string }) {
  return (
    <div className={cn("markdown-body text-sm leading-relaxed", className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} rehypePlugins={[rehypeKatex]}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
